import { Directive } from '@angular/core';
import { Util } from '@libs/utilities/util';

import { NgSliderElementDirective } from './slider-element.directive';


@Directive({
    selector: '[ngCustomizableSliderLabel]',
    standalone: false
})
export class NgSliderLabelDirective extends NgSliderElementDirective {

	//** Helper Variables */
	private currentValue: string = null!;
	get value(): string { return this.currentValue; }


	//** Update slider label */
	setValue(value: string): void {

		//0 - set recalculate dimension
		let recalculateDimension: boolean = false;
		if (!this.alwaysHide && (Util.Basic.isUndefined(this.value) || this.value.length !== value.length || (this.value.length > 0 && this.dimension === 0))) recalculateDimension = true;

		//1 - set current value and update dimension
		this.currentValue = value;
		this.elemRef.nativeElement.innerHTML = value;
		if (recalculateDimension) this.calculateDimension();
	}
}
